module.exports = __webpack_public_path__ + "static/media/pdf_icon.2ff9d8ab.svg";